import * as React from 'react'
import {
  PaymentTypeIds,
  convertPaymentTypeIdToName,
  TransactionContract,
  isTerminalTransaction,
  IPayment,
} from '@getgreenline/homi-shared'
import { Currency } from '../Currency'
import { observer } from 'mobx-react'
import { Select } from 'antd'

interface Props {
  transaction: TransactionContract
  payment: IPayment
  changePennyAdjustment: (amount: number) => void
  editPaymentPennyAdjustment: number
}

interface State {
  isOriginalTransactionCash: boolean
}

@observer
export class ChangePaymentTypeDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isOriginalTransactionCash: props.transaction.paymentTypeId === PaymentTypeIds.cash,
    }
  }

  onTerminalInvoiceIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { transaction } = this.props

    const terminalInvoiceId: string | null =
      event.target.value.length === 0 ? null : event.target.value

    transaction.setTerminalInvoiceId(terminalInvoiceId)
  }

  onChangePayment = (paymentTypeId: number) => {
    const { transaction, payment, changePennyAdjustment, editPaymentPennyAdjustment } = this.props
    const { isOriginalTransactionCash } = this.state

    if (isOriginalTransactionCash) {
      const originalPaymentPennyAdjustment = payment.pennyAdjustment

      if (transaction.paymentTypeId === PaymentTypeIds.cash && editPaymentPennyAdjustment !== 0) {
        const newAmount = transaction.amount - originalPaymentPennyAdjustment
        transaction.setAmount(newAmount)
        changePennyAdjustment(0)
      } else if (
        paymentTypeId === PaymentTypeIds.cash &&
        editPaymentPennyAdjustment === 0 &&
        originalPaymentPennyAdjustment !== 0
      ) {
        const newAmount = transaction.amount + originalPaymentPennyAdjustment
        transaction.setAmount(newAmount)
        changePennyAdjustment(originalPaymentPennyAdjustment)
      }
    }

    transaction.setPaymentTypeId(paymentTypeId)
  }

  get paymentOptions() {
    return [
      { label: convertPaymentTypeIdToName(PaymentTypeIds.cash), value: PaymentTypeIds.cash },
      { label: convertPaymentTypeIdToName(PaymentTypeIds.debit), value: PaymentTypeIds.debit },
      { label: convertPaymentTypeIdToName(PaymentTypeIds.credit), value: PaymentTypeIds.credit },
      { label: convertPaymentTypeIdToName(PaymentTypeIds.other), value: PaymentTypeIds.other },
      { label: convertPaymentTypeIdToName(PaymentTypeIds.moneris), value: PaymentTypeIds.moneris },
      { label: convertPaymentTypeIdToName(PaymentTypeIds.merrco), value: PaymentTypeIds.merrco },
      {
        label: convertPaymentTypeIdToName(PaymentTypeIds.blazepay),
        value: PaymentTypeIds.blazepay,
      },
    ]
  }

  render() {
    const {
      transaction: { terminalInvoiceId, paymentTypeId, amount },
    } = this.props
    const terminalInvoiceIdRequired = isTerminalTransaction(paymentTypeId)
    const terminalInvoiceIdError = terminalInvoiceIdRequired && terminalInvoiceId === null
    const dropdownValue = {
      label: convertPaymentTypeIdToName(paymentTypeId),
      value: paymentTypeId,
    }

    return (
      <>
        <div style={{ alignItems: 'baseline' }} className='d-flex w-100 row mr-3 padding'>
          <div className='w-50 mr-5'>
            <Select
              className='w-100'
              size='large'
              value={dropdownValue.label}
              options={this.paymentOptions}
              disabled={paymentTypeId === PaymentTypeIds.loyalty}
              onChange={(paymentTypeId: any) => this.onChangePayment(paymentTypeId)}
            >
              {this.paymentOptions.map((paymentType) => {
                return (
                  <Select.Option
                    className={paymentType.value === dropdownValue.value ? 'ant-selected-item' : ''}
                    key={paymentType.value}
                    value={paymentType.value}
                    disabled={paymentType.value === PaymentTypeIds.loyalty}
                  >
                    {paymentType.label}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
          <h4>
            <Currency centValue={amount} />
          </h4>
        </div>
        <div className='row padding'>
          {terminalInvoiceIdRequired && <div className='auth-input w-100'>Transaction Auth #</div>}
          {terminalInvoiceIdRequired && (
            <div>
              <input
                style={{ width: '123%' }}
                className={`form-control ${terminalInvoiceIdError ? 'invalid' : ''}`}
                value={terminalInvoiceId || ''}
                onChange={this.onTerminalInvoiceIdChange}
              />
            </div>
          )}
        </div>
        {terminalInvoiceIdError && (
          <div className='row w-100 padding'>
            <small className='error-message'>Please enter transaction auth #.</small>
          </div>
        )}
      </>
    )
  }
}
